var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 0C9.85 0 0 9.90063 0 22.1131C0 33.1998 8.125 42.3536 18.712 43.9528V27.9741H13.269V22.1613H18.712V18.2935C18.712 11.8898 21.816 9.07842 27.111 9.07842C29.647 9.07842 30.988 9.26739 31.623 9.35383V14.4278H28.011C25.763 14.4278 24.978 16.5697 24.978 18.9841V22.1613H31.566L30.672 27.9741H24.978V44C35.716 42.5355 44 33.3073 44 22.1131C44 9.90063 34.15 0 22 0Z",
    fill: "#3B457B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.13b1e3295efcecc2ffb2703b3244a22b.svg";
export { ForwardRef as ReactComponent };